/**
 * Document titles for Admin SPA tracking (browser tab, Sentry transaction name,
 * analytics). Shopify embedded apps still benefit from distinct titles per route.
 */
const APP = "SafeGeo";

const ROUTES: Array<{ test: (path: string) => boolean; title: string }> = [
  { test: (p) => p === "/app/welcome" || p === "/welcome", title: "Welcome" },
  { test: (p) => p === "/app/billing", title: "Billing" },
  { test: (p) => p === "/app/plans" || p === "/app/plan" || p === "/plans" || p === "/app/billing", title: "Plan" },
  { test: (p) => p === "/app/market" || p === "/app/markets", title: "Market redirect" },
  { test: (p) => p === "/app/redirects", title: "Market redirect" },
  { test: (p) => p === "/app/stores/new" || p === "/app/block/new", title: "Add destination" },
  { test: (p) => /^\/app\/stores\/[^/]+$/.test(p), title: "Edit store redirect" },
  { test: (p) => /^\/app\/block\/[^/]+$/.test(p), title: "Edit block" },
  { test: (p) => p === "/app/stores", title: "Store redirect" },
  { test: (p) => p === "/app/block", title: "Block country" },
  { test: (p) => p === "/app/popup" || p === "/app/design", title: "Popup" },
  { test: (p) => p === "/app/settings", title: "Settings" },
  { test: (p) => p === "/app/help", title: "Help" },
  { test: (p) => p === "/app" || p === "/" || p === "", title: "Home" },
];

export function screenTitleForPath(pathname: string): string {
  const path = pathname.replace(/\/+$/, "") || "/";
  const hit = ROUTES.find((r) => r.test(path));
  return hit ? `${hit.title} · ${APP}` : `${APP}`;
}

export function screenKeyForPath(pathname: string): string {
  const path = pathname.replace(/\/+$/, "") || "/";
  if (path === "/app/welcome" || path === "/welcome") return "welcome";
  if (path === "/app/billing") return "billing";
  if (path === "/app/plans" || path === "/app/plan" || path === "/plans")
    return "plans";
  if (path === "/app/market" || path === "/app/markets" || path === "/app/redirects")
    return "market";
  if (path === "/app/stores/new" || path === "/app/block/new") return "form_new";
  if (/^\/app\/stores\/[^/]+$/.test(path)) return "stores_edit";
  if (/^\/app\/block\/[^/]+$/.test(path)) return "block_edit";
  if (path === "/app/stores") return "stores";
  if (path === "/app/block") return "block";
  if (path === "/app/popup" || path === "/app/design") return "popup";
  if (path === "/app/settings") return "settings";
  if (path === "/app/help") return "help";
  if (path === "/app" || path === "/" || path === "") return "home";
  return "unknown";
}
